<section id="wire-transfer-section" class="section-card-content" data-cy="deposit-wire-screen">
  <!-- <form [formGroup]="wireTransferForm"> -->
    <form>
    <p class="details tw-text-[15px] tw-text-[#0F2950]" data-cy="deposit-wire-details">
      To Fund your
      <a href="http://amwager.com/" class="tw-text-[#5495F7] tw-underline" data-cy="deposit-wire-link-1">AmWager.com</a>
      account via wire transfer
      provide your financial institution with the following:
    </p>

    <p class="reminder tw-text-[16px] tw-text-[#3080EC] tw-mt-[13px] tw-mb-[28px]" data-cy="deposit-wire-reminder">
      <span>*</span>A service charge of $25 will apply to wires requested under $5000.
    </p>

    <div class="deposit-details tw-mb-[30px]">

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-account-name">
            Account Name:
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-amwest">
            AmWest Entertainment, LLC
          </span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-account-number-text">
            Account Number:
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-account-number">5314877993</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-routing">
            ABA/Routing:
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-routing-number">042200910</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-bank-name">
            Bank Name:
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-financial-bank">First Financial Bank</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-bank-address">
            Bank Address:
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-wire-full-address">
            255 E. Fifth St. Suite 800 Cincinnati, OH 45202
          </span>
        </div>
      </div>

    </div>

    <!-- <div class="amount-row tw-relative">
      Message section

      <span class="tw-absolute tw-bottom-[-19px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        Required
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['amount'] && formVal['amount']?.errors
            && (formVal['amount'].touched || formVal['amount'].dirty)"
          data-cy="card-deposit-amount-error"
        >
          {{
            formVal['amount']?.errors?.['min']
              ? 'Cannot deposit less than $25.'
              : formVal['amount']?.errors?.['max']
                ? 'Cannot deposit greater than $10,000.'
                : 'Please enter valid amount.'
          }}
        </span>
      </span>

      <span class="amount-deposit-usd tw-block tw-text-[16px] tw-text-[#5D5D5D]">
        Amount Deposit in USD
      </span>
      <input
        formControlName="amount"
        id="depositAmount"
        (keyup)="depositAmount()"
        type="number"
        min="25"
        max="10000"
        class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
        placeholder=""
        pattern="^\d+(\.\d{1,2})?$"
        amwager3DecimalInput
        data-cy="card-deposit-input"
      />
    </div>

    <button
      (click)="deposit()"
      [ngClass]="{'active': (amount && !isDepositing && formVal['amount'].valid)}"
      [disabled]="!amount || isDepositing || formVal['amount'].invalid"
      class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[30px] tw-mb-[10px]"
    >
    {{
      isDepositing
        ? 'Depositing...'
        : 'Deposit Now'
    }}
    </button> -->

    <p class="notice tw-text-center tw-text-[16px] tw-text-[#0F2950]" data-cy="deposit-wire-bottom-text">
      Funds will be deposited into your
      <a href="http://amwager.com/" class="tw-text-[#3080EC] tw-underline" data-cy="deposit-wire-link-2">AmWager.com</a>
      account after they are received from your financial
      institution. Please contact support once a wire has
      been initiated with the amount.
    </p>
  </form>
</section>
